import { platformFetch } from "services/platformFetch";
import { auth } from "services/firebase";
export async function getDashboard() {
  if (!auth?.currentUser) throw new Error("Entre na sua conta para continuar.");
  const response = await platformFetch("/api/dashboard", {
    headers: { Authorization: `Bearer ${await auth.currentUser.getIdToken()}` },
    cache: "no-store",
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Não foi possível carregar o painel.");
  return body;
}
